<ngx-spinner type="square-jelly-box">
  <h3>Loading...</h3>
</ngx-spinner>

@if (themeReady) {
<div  class="page-wrap" [lxResponsiveClass]="{ horizontal: 'page-wrap-desktop', vertical: 'page-wrap-handset' }">
  <div class="offers-wrapper">
    <div class="offers">
      <div [hidden]="!this.invalidCode">
        <mat-card class="confirmation-card not-available-text">
          <p>Your confirmation has expired. Please click resend.</p>
        </mat-card>
      </div>

      @if ({offerConfirmation: offerConfirmation$ | async, error: offerErrors$ | async}; as data) {
        <div [hidden]="this.invalidCode">
          <div [hidden]="data.error ? true : false">
            @if (data.offerConfirmation) {
              @if (data.offerConfirmation.length === 1) {
                <mat-card class="confirmation-card not-available-text">
                  <p>Thank you for placing your request!</p>
                  <p>
                    Your request to upgrade to a
                    <span class="bold">{{data.offerConfirmation[0].room_category_name | titlecase}}</span> for
                     {{data.offerConfirmation[0].gross_ofr_price | currency:'USD'}} with tax has been placed!
                    You should receive an email confirming your request shortly.
                    You may also check the status of your request
                    <span (click)="this.navigateToOfferStatus()" class="status-link">here</span>.
                  </p>
                  <p>
                    The property team will typically review and accept requests within 24 hours of submission
                    and you will be notified via an email communication.
                    If a request is declined, this is typically due to extenuating inventory circumstances preventing the upgrade at this time,
                    but you may still ask about available upgrades upon check-in!
                  </p>
                </mat-card>
              }

              @if (data.offerConfirmation.length > 1) {
                <mat-card class="confirmation-card">
                  <p>Thank you for placing your upgrade requests!</p>
                  <p>The details of your request(s) are below:</p>
                  <app-shopping-cart-table
                    [offers]="data.offerConfirmation"
                    [offerAliasId]="offerAliasId"
                    [propertyId]="propertyId"
                    [displayRemovalButtons]="false">
                  </app-shopping-cart-table>
                  <p class="footer-text">
                    The property team will typically review and accept requests within 24 hours of submission
                    and you will be notified via an email communication.
                  </p>
                </mat-card>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
}
